<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      requester: ""
    };
  },

  methods: {
    ...mapActions("newOrder", ["setRequester"])
  },

  watch: {
    requester(requester) {
      this.setRequester(requester);
    }
  }
};
</script>

<template>
  <v-container>
    <v-layout column justify-center class="section-title">
      <div>requisitado por</div>
      <hr />
    </v-layout>

    <v-layout column align-center>
      <v-radio-group v-model="requester" row>
        <v-radio label="Cliente" value="customer" />
        <v-radio label="Profissional" value="professional" />
      </v-radio-group>
    </v-layout>

    <v-layout row justify-center>
      <p class="accent--text">
        As regras se aplicarão conforme a escolha acima!
      </p>
    </v-layout>
  </v-container>
</template>

<style scoped>
.v-radio {
  border: 2px solid#e5e5e5;
  padding: 15px 20px;
  border-radius: 10px;
  transition: all 0.25s ease;
}

.v-radio.accent--text {
  border-color: var(--pink);
}

.v-radio label.v-label {
  color: var(--pink) !important;
}

.warning-message {
  color: #ff1919;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Orders/Rebooking/RequiredBy.vue